/* eslint-disable */
// @ts-nocheck
import { BytesLike, BigNumber, BigNumberish } from 'ethers';
import { contract, Call, Send, AddressLike, Contract } from '@enzymefinance/ethers';



// prettier-ignore
export interface ITestCurveAddressProvider extends Contract<ITestCurveAddressProvider> {
  get_address: Call<(_id: BigNumberish) => string, ITestCurveAddressProvider>
  'get_address(uint256)': Call<(_id: BigNumberish) => string, ITestCurveAddressProvider>
  get_registry: Call<() => string, ITestCurveAddressProvider>
  'get_registry()': Call<() => string, ITestCurveAddressProvider>
}

let ITestCurveAddressProviderBytecode: string | undefined = undefined;
if (typeof window === 'undefined') {
  ITestCurveAddressProviderBytecode = '0x';
}

// prettier-ignore
export const ITestCurveAddressProvider = contract<ITestCurveAddressProvider>(ITestCurveAddressProviderBytecode)`
  function get_address(uint256 _id) view returns (address address_)
  function get_registry() view returns (address registry_)
`;